import React, { useState, useRef, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SignatureCanvas from "react-signature-canvas";
import { MdPhotoCamera } from "react-icons/md";
import { Tick } from "../../../icons/Tick";
import Navbar from "../../Navbar/navbar";
import axios from "axios";
import { baseUrl } from "../../../Environments/environment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import DateandTimePicker from "../Addon/DateandTimePicker";
import BottomSheetModal from "./BottomSheetModal";
import CustomTimePicker from "./CustomTimePicker";
import {
  addSelectedAddOn,
  filterAddOnRequests,
  filterCheckInOutRequsts,
  setAllAddOns,
  setEarlyCheckInTime,
  setGuestAddons,
  setGuestCheckInOutRequests,
  setLateCheckOutTime,
} from "../../../redux/addOn/addOnSlice";

import LateCheckoutTimePicker from "../Addon/LateCheckoutTimePicker";
import DateandTimePicker2 from "./DateTimePicker2";
import ArrivalTimePicker from "./ArrivalTimePicker";

const customStyles = {
  "--react-datepicker-time-list-bg": "white",
};

export const PRE_ARRIVAL_INPUT = {
  REQUIRED: "required",
  OPTIONAL: "optional",
  DISABLED: "disabled",
};
const getFormattedDate = () => {
  const today = new Date();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // getMonth() returns month from 0-11, so add 1
  const day = String(today.getDate()).padStart(2, "0");
  const year = today.getFullYear();

  return `${month}/${day}/${year}`;
};
const convert24to12 = (time24) => {
  console.log("Time24:", time24);
  try {
    return moment(time24, "HH:mm").format("hh:mm A");
  } catch (error) {
    console.error("Error converting 24h to 12h format:", error);
    return "";
  }
};

// Convert 12-hour format to 24-hour format
const convert12to24 = (time12) => {
  try {
    return moment(time12, "hh:mm A").format("HH:mm");
  } catch (error) {
    console.error("Error converting 12h to 24h format:", error);
    return "";
  }
};
const PreArrivalCheckIn = () => {
  const navigate = useNavigate();
  const sigCanvas = useRef(null);
  const fileInputRef = useRef(null);
  const guestid = useParams();
  const guestSessionId = guestid.id;
  const [counter, setCounter] = useState(0);
  const [isDrawing, setIsDrawing] = useState(false);
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [preArrivalLoading, setPreArrivalLoading] = useState(false);
  const [arrivalTime, setArrivalTime] = useState("");
  const [vehicleMake, setVehicleMake] = useState("");
  const [licensePlate, setLicensePlate] = useState("");
  const [specialRequests, setSpecialRequests] = useState("");
  const [agreePolicies, setAgreePolicies] = useState(false);
  const [consentTexts, setConsentTexts] = useState(false);
  // const [smsPolicies, setSmsPolicies] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const guestSignature = useSelector((state) => state.guest.guestSignature);
  const [signature, setSignature] = useState(guestSignature); // This will now store base64 string
  const [idProof, setIdProof] = useState(null);
  const [idProofError, setIdProofError] = useState(false);
  const [signatureError, setSignatureError] = useState(false);
  const [vehicleMakeError, setVehicleMakeError] = useState(false);
  const [licensePlateError, setLicensePlateError] = useState(false);
  const [preArrivalFlow, setPreArrivalFlow] = useState(null);
  const [addOns, setAddOns] = useState(null);
  const [guest, setGuest] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLateCheckOutModalOpen, setIsLateCheckOutModalOpen] = useState(false);
  const [selectedAddOn, setSelectedAddOn] = useState(null); // Store selected add-on for the modal
  const [selectedPolicy, setSelectedPolicy] = useState(null); // To store the selected policy
  const [isPolicyModalOpen, setIsPolicyModalOpen] = useState(false); // To control modal visibility
  const [checkedPolicies, setCheckedPolicies] = useState({}); // To track checkbox state
  const [propertyCheckInTime, setPropertyCheckInTime] = useState("");
  const [propertyCheckOutTime, setPropertyCheckOutTime] = useState("");
  const [propertyEarlyCheckInTime, setPropertyEarlyCheckInTime] = useState("");
  const [propertyLateCheckOutTime, setPropertyLateCheckOutTime] = useState("");
  const [selectedDate, setSelectedDate] = useState(getFormattedDate());
  const [lateCheckoOutSelectedTime, setLateCheckoOutSelectedTime] =
    useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loadingAddOnId, setLoadingAddOnId] = useState(null);
  const [isLateCheckOutLoading, setIsLateCheckOutLoading] = useState(false);
  const [isEarlyCheckInLoading, setIsEarlyCheckInLoading] = useState(false);
  const [showEarlyCheckInButton, setShowEarlyCheckInButton] = useState(false);
  const [showLateCheckOutButton, setShowLateCheckOutButton] = useState(false);
  const [requestStatus, setRequestStatus] = useState(null);
  const [lateCheckoutRequestStatus, setlateCheckoutRequestStatus] =
    useState(null);
  const [propertyTimeZone, setPropertyTimeZone] = useState(null);
  const dispatch = useDispatch();
  const storeAddOns = useSelector((state) => state.addOn);
  const [selectedTime, setSelectedTime] = useState(propertyCheckInTime);
  const [viewPolicy, setViewPolicy] = useState(null);
  console.log("Property Setting, ", propertyCheckInTime);
  const handleCheckboxChange = (name) => {
    setCheckedPolicies((prev) => {
      const updated = { ...prev, [name]: !prev[name] };

      // If the policy is checked, remove any validation error for that policy
      if (updated[name]) {
        setValidationErrors((errors) => ({ ...errors, [name]: false }));
      }

      return updated;
    });
    const selected = preArrivalFlow.propertyPolicies.find(
      (policy) => policy.name === name
    );
    setSelectedPolicy(selected); // Set the selected policy
    // setIsPolicyModalOpen(true); // Open the bottom sheet/modal
  };
  function handleViewPolicy(policy) {
    setViewPolicy(policy);
    setIsPolicyModalOpen(true); // Open the modal
  }
  const validatePolicies = () => {
    const errors = {};
    preArrivalFlow.propertyPolicies.forEach((policy) => {
      if (policy.isMandatory && !checkedPolicies[policy.name]) {
        errors[policy.name] = true; // Mark as error if not checked
      }
    });
    setValidationErrors(errors);

    // Check if there are no errors to proceed
    return Object.keys(errors).length === 0;
  };

  const closeModal = () => {
    setIsPolicyModalOpen(false); // Close the modal
    setSelectedPolicy(null); // Clear the selected policy
  };

  const getWorkFlow = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/guestApi/${guestSessionId}/workflow`
      );

      setPreArrivalFlow(response.data.result.preArrivalFlow);
      console.log(response.data.result.preArrivalFlow);
      setPropertyCheckInTime(
        response.data.result.settingFlow.standardCheckinTime
      );
      // dispatch(
      //   setPropertyCheckInTime(
      //     response.data.result.settingFlow.standardCheckinTime
      //   )
      // );
      setArrivalTime(response.data.result.settingFlow.standardCheckinTime);
      setPropertyTimeZone(response.data.result.settingFlow.timezone);

      // dispatch(
      //   setPropertyCheckOutTime(
      //     response.data.result.settingFlow.standardCheckoutTime
      //   )
      // );
      setPropertyCheckOutTime(
        response.data.result.settingFlow.standardCheckoutTime
      );
      if (
        response.data.result &&
        response.data.result.addOnsFlow &&
        response.data.result.addOnsFlow.checkInOutAddOns.length > 0 &&
        response.data.result.addOnsFlow.checkInOutAddOns[0].enabled
      ) {
        setPropertyEarlyCheckInTime(
          response.data.result.addOnsFlow.checkInOutAddOns[0]
        );
        // dispatch(
        //   setPropertyEarlyCheckInTime(
        //     response.data.result.addOnsFlow.checkInOutAddOns[0]
        //   )
        // );
      }

      if (
        response.data.result &&
        response.data.result.addOnsFlow &&
        response.data.result.addOnsFlow.checkInOutAddOns.length > 0 &&
        response.data.result.addOnsFlow.checkInOutAddOns[1].enabled
      ) {
        setPropertyLateCheckOutTime(
          response.data.result.addOnsFlow.checkInOutAddOns[1]
        );
        // dispatch(
        //   setPropertyLateCheckOutTime(
        //     response.data.result.addOnsFlow.checkInOutAddOns[1]
        //   )
        // );
      }

      const tempArr = [
        ...response.data.result.addOnsFlow.checkInOutAddOns,
        ...response.data.result.addOnsFlow.customAddOns,
      ];

      setAddOns(tempArr);
      dispatch(setAllAddOns(tempArr));
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const getGuestCheckInOutRequests = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/guestApi/${guestSessionId}/checkInOutRequest`
      );
      dispatch(setGuestCheckInOutRequests(response.data.result));
      dispatch(filterCheckInOutRequsts(response.data.result));
    } catch (error) {
      console.error("Error fetching guest data:", error);
    }
  };
  const getGuestAddons = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/guestApi/${guestSessionId}/addOns`
      );
      dispatch(filterAddOnRequests(response.data.result));
      dispatch(setGuestAddons(response.data.result));
    } catch (error) {
      console.error("Error fetching guest data:", error);
    }
  };

  useEffect(() => {
    getGuestCheckInOutRequests();
    getGuestAddons();
  }, [requestStatus, lateCheckoutRequestStatus, isLoading]);
  const handleEarlyCheckInAddon = async (time) => {
    const formattedTime = convert12to24(time);
    console.log("Attempt", formattedTime);
    const data = {
      earlyCheckInDateTime: formatDateTime(
        moment(guest.checkIn).format("DD-MM-YYYY"),
        formattedTime
      ),
      requestType: "earlyCheckIn",
      checkInOutRequestId: addOns[0]._id,
    };
    console.log("Request", data.earlyCheckInDateTime);
    try {
      setIsLoading(true);
      setRequestStatus("idle");
      setIsEarlyCheckInLoading(true);
      setLoadingAddOnId(addOns[0]._id);
      const response = await axios.post(
        `${baseUrl}/guestApi/${guestSessionId}/checkInOutRequest`,
        data
      );

      if (response.status === 200) {
        setRequestStatus("success"); // Update the request status to success
        dispatch(addSelectedAddOn(addOns[0]));
        // console.log("Request sent successfully!");
      } else {
        setRequestStatus("failure"); // Update the request status to failure
        //console.log("Request failed. Please try again.");
      }
    } catch (error) {
      setRequestStatus("failure"); // Update the request status to failure
      console.log(error);
      toast.error("Request failed. Please try again.");
    } finally {
      setIsEarlyCheckInLoading(false);
      setLoadingAddOnId(null);
      setIsLoading(false); // Ensure loading state is reset
    }
  };

  const handleLateCheckOutAddon = async (time) => {
    const formattedTime = convert12to24(time);
    console.log("aaaaaaa", formattedTime);
    const data = {
      lateCheckOutDateTime: formatDateTime(
        moment(guest.checkOut).format("DD-MM-YYYY"),
        formattedTime
      ),
      requestType: "lateCheckOut",
      checkInOutRequestId: addOns[1]._id,
    };

    try {
      setIsLateCheckOutLoading(true);
      setLoadingAddOnId(addOns[1]._id);
      const response = await axios.post(
        `${baseUrl}/guestApi/${guestSessionId}/checkInOutRequest`,
        data
      );

      if (response.status === 200) {
        setlateCheckoutRequestStatus("success"); // Update the request status to success
        dispatch(addSelectedAddOn(addOns[1]));
        //dispatch(setLateCheckOutTime(time));
        //console.log("Request sent successfully!");
      } else {
        setlateCheckoutRequestStatus("failure"); // Update the request status to failure
        // console.log("Request failed. Please try again.");
      }
    } catch (error) {
      setlateCheckoutRequestStatus("failure"); // Update the request status to failure
      console.log(error);
      //toast.error("Request failed. Please try again.");
    } finally {
      setLoadingAddOnId(null);
      setIsLateCheckOutLoading(false); // Ensure loading state is reset
    }
  };

  useEffect(() => {
    getWorkFlow();
  }, []);

  useEffect(() => {
    if (selectedTime && selectedTime !== propertyCheckInTime) {
      setShowEarlyCheckInButton(true);
    } else {
      setShowEarlyCheckInButton(false);
    }
  }, [selectedTime, propertyCheckInTime]);
  useEffect(() => {
    if (
      lateCheckoOutSelectedTime &&
      lateCheckoOutSelectedTime !== propertyCheckOutTime
    ) {
      setShowLateCheckOutButton(true);
    } else {
      setShowLateCheckOutButton(false);
    }
  }, [lateCheckoOutSelectedTime, propertyCheckOutTime]);

  const handleSendRequest = (addOn) => {
    setSelectedAddOn(addOn);
    if (addOn.addOnType != "CustomAddon") {
      setIsModalOpen(true);
    } else {
      handleConfirmRequest(addOn);
    } // Open modal
  };
  const handleConfirmRequest = async (addOn) => {
    await sendRequestToBackend(addOn);

    setIsModalOpen(false); // Close modal
  };

  const sendRequestToBackend = async (selectedAddOn) => {
    const data = {
      addOnsId: selectedAddOn._id,
    };
    try {
      setIsLoading(true);
      setLoadingAddOnId(selectedAddOn._id);
      const response = await axios.post(
        `${baseUrl}/guestApi/${guestSessionId}/addOnsRequest`,
        data
      );

      if (response.status === 201) {
        setRequestStatus("success"); // Update the request status to success
        dispatch(addSelectedAddOn(selectedAddOn));
        // console.log("Request sent successfully!");
      } else {
        setRequestStatus("failure"); // Update the request status to failure
        // console.log("Request failed. Please try again.");
      }
    } catch (error) {
      setRequestStatus("failure"); // Update the request status to failure
      console.log(error);
      toast.error("Request failed. Please try again.");
    } finally {
      setLoadingAddOnId(null);
      setIsLoading(false); // Ensure loading state is reset
    }
  };
  const getGuest = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/guestApi/${guestSessionId}/guest`
      );
      setGuest(response.data.result);
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (preArrivalFlow) {
        await getGuest();
      }
    };

    fetchData();
  }, [preArrivalFlow]);

  useEffect(() => {
    if (guest) {
      const mergedPhone = `${guest?.countryCode?.replace(/\D/g, "")}${
        guest.phoneNumber
      }`;
      setPhone(mergedPhone);
      // Set country code and phone number separately
      const guestCountryCode = guest?.countryCode || "";
      const guestPhoneNumber = guest?.phoneNumber || "";
      setCountryCode(guestCountryCode);
      setPhoneNumber(guestPhoneNumber);
      setEmail(guest.email);
    }
  }, [guest]);
  const checkEmail = (email) => {
    if (preArrivalFlow.emailAddress !== PRE_ARRIVAL_INPUT.REQUIRED) {
      return true;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(email);

    setEmailError(!isValidEmail);
    return isValidEmail;
  };

  const checkLicensePlate = (licensePlate) => {
    if (preArrivalFlow.licensePlateNo !== PRE_ARRIVAL_INPUT.DISABLED && licensePlate) {
      return true;
    }
    return false;
  };

  // Validation function for third page (arrival time page)
  const validateThirdPage = () => {
    const errors = {};
    const missingFields = [];
    let isValid = true;

    // Validate license plate if required
    if (preArrivalFlow.licensePlateNo === PRE_ARRIVAL_INPUT.REQUIRED && (!licensePlate || !licensePlate.trim())) {
      errors.licensePlate = true;
      missingFields.push("License Plate");
      isValid = false;
    }

    // Set error states
    setLicensePlateError(errors.licensePlate || false);

    // Show toast with missing fields if validation fails
    if (!isValid && missingFields.length > 0) {
      const fieldList = missingFields.join(", ");
      console.log("Third page validation failed. Missing fields:", missingFields);
      toast.error(`Please fill in the following required fields: ${fieldList}`);
    }

    return isValid;
  };

  // Save signature as base64 string on every change
  const saveSignatureToState = () => {
    if (sigCanvas.current) {
      const dataUrl = sigCanvas.current.toDataURL();
      setSignature(dataUrl); // Save as base64 string
    }
  };

  // Helper: convert data URL to Blob
  const dataUrlToBlob = (dataUrl) => {
    try {
      const parts = dataUrl.split(",");
      const mime = parts[0].match(/:(.*?);/)[1];
      const bstr = atob(parts[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    } catch (e) {
      return null;
    }
  };

  // Ref callback to restore as soon as canvas mounts
  const handleSigCanvasRef = (ref) => {
    sigCanvas.current = ref;
    if (
      ref &&
      signature &&
      typeof signature === "string" &&
      signature.startsWith("data:image")
    ) {
      try {
        ref.fromDataURL(signature);
      } catch (e) {
        // ignore if invalid
      }
    }
  };

  // Restore signature from state if it exists
  useEffect(() => {
    if (
      sigCanvas.current &&
      signature &&
      typeof signature === "string" &&
      signature.startsWith("data:image")
    ) {
      try {
        sigCanvas.current.fromDataURL(signature);
      } catch (e) {
        // ignore if invalid
      }
    }
    // eslint-disable-next-line
  }, [signature, counter, isModalOpen]);

  // On mobile, canvas can be cleared on scroll/orientation/resize/visibility changes.
  // Rehydrate from state if canvas becomes empty.
  useEffect(() => {
    const restoreIfEmpty = () => {
      try {
        if (
          sigCanvas.current &&
          typeof sigCanvas.current.isEmpty === "function" &&
          sigCanvas.current.isEmpty() &&
          signature &&
          typeof signature === "string" &&
          signature.startsWith("data:image")
        ) {
          sigCanvas.current.fromDataURL(signature);
        }
      } catch (e) {
        // ignore
      }
    };

    window.addEventListener("scroll", restoreIfEmpty, { passive: true });
    window.addEventListener("resize", restoreIfEmpty);
    window.addEventListener("orientationchange", restoreIfEmpty);
    document.addEventListener("visibilitychange", restoreIfEmpty);

    return () => {
      window.removeEventListener("scroll", restoreIfEmpty);
      window.removeEventListener("resize", restoreIfEmpty);
      window.removeEventListener("orientationchange", restoreIfEmpty);
      document.removeEventListener("visibilitychange", restoreIfEmpty);
    };
  }, [signature]);

  // Comprehensive validation function for first page
  const validateFirstPage = () => {
    const errors = {};
    const missingFields = [];
    let isValid = true;

    // Validate email - ALWAYS MANDATORY
    if (!email || !checkEmail(email)) {
      errors.email = true;
      missingFields.push("Email address");
      isValid = false;
    }

    // Validate ID proof - ALWAYS MANDATORY
    if (!idProof) {
      errors.idProof = true;
      missingFields.push("Photo ID proof");
      isValid = false;
    }

    // Validate signature - ALWAYS MANDATORY
    if (!sigCanvas.current || sigCanvas.current.isEmpty()) {
      errors.signature = true;
      missingFields.push("Signature");
      isValid = false;
    }


    // Note: Mobile number is already pre-filled and disabled, so no validation needed
    // Vehicle make, license plate, special requests, and policies are optional

    // Set error states
    setEmailError(errors.email || false);
    setIdProofError(errors.idProof || false);
    setSignatureError(errors.signature || false);
    setVehicleMakeError(false); // Always false since it's optional
    setLicensePlateError(false); // Always false since it's optional

    // Show toast with missing fields if validation fails
    if (!isValid && missingFields.length > 0) {
      const fieldList = missingFields.join(", ");
      console.log("Validation failed. Missing fields:", missingFields);
      toast.error(`Please fill in the following required fields: ${fieldList}`);
    }

    return isValid;
  };

  const saveSignature = () => {
    // First validate all required fields
    if (!validateFirstPage()) {
      return; // Don't proceed if validation fails
    }

    const canvas = sigCanvas.current.getTrimmedCanvas();
    const signatureData = canvas.toDataURL("image/png");
    setSignature(signatureData); // Save base64 string to state

    // Convert base64 to Blob
    const byteString = atob(signatureData.split(",")[1]);
    const mimeString = signatureData.split(",")[0].split(":")[1].split(";")[0];

    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([uint8Array], { type: mimeString });
    
    // Clear any previous errors since validation passed
    setEmailError(false);
    setIdProofError(false);
    setSignatureError(false);
    setVehicleMakeError(false);
    setLicensePlateError(false);
    
    handleSubmit(blob); // Pass blob to handleSubmit
  };

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setIdProofError(false);
      setIdProof(file);
    }
  };

  const navigateHome = async () => {
    navigate(`/${guestSessionId}`);
    await getWorkFlow();
  };
  const handleSubmit = (signatureBlob) => {
    if (counter == 0) {
      // On first page, validation is already done in validateFirstPage()
      // Just increment counter to go to next page
      setCounter(counter + 1);
    } else if (counter == 2) {
      // On third page (arrival time), validate third page fields first
      if (!validateThirdPage()) {
        return; // Don't proceed if validation fails
      }
      // Submit the form
      handlePreArrivalCheckIn(signatureBlob);
    } else {
      setCounter(counter + 1);
    }
  };
  const clearSignature = () => {
    sigCanvas.current.clear();
    setIsDrawing(false);
    setSignature(""); // Clear signature from state
  };

  const handleBegin = () => {
    setIsDrawing(true);
  };

  const handlePreArrivalCheckIn = async (signatureBlob) => {
    setPreArrivalLoading(true);
    const formData = new FormData();

    if (preArrivalFlow.phoneNumber !== PRE_ARRIVAL_INPUT.DISABLED && (countryCode || phoneNumber)) {
      formData.append("countryCode", String(countryCode));
      formData.append("phoneNumber", String(phoneNumber));
    }
    if (preArrivalFlow.emailAddress !== PRE_ARRIVAL_INPUT.DISABLED && email) {
      formData.append("emailAddress", String(email));
    }
    if (
      preArrivalFlow.arrivalTime !== PRE_ARRIVAL_INPUT.DISABLED &&
      arrivalTime
    ) {
      formData.append("arrivalTime", String(arrivalTime));
    }
    if (
      preArrivalFlow.vehicleMakeModelColor !== PRE_ARRIVAL_INPUT.DISABLED &&
      vehicleMake
    ) {
      formData.append("vehicleMakeModelColor", String(vehicleMake));
    }
    if (
      preArrivalFlow.licensePlateNo !== PRE_ARRIVAL_INPUT.DISABLED &&
      licensePlate
    ) {
      formData.append("licensePlateNo", String(licensePlate));
    }
    if (
      preArrivalFlow.specialRequests !== PRE_ARRIVAL_INPUT.DISABLED &&
      specialRequests
    ) {
      formData.append("specialRequests", String(specialRequests));
    }
    if (preArrivalFlow.guestIdProof !== PRE_ARRIVAL_INPUT.DISABLED && idProof) {
      formData.append("guestIdProof", idProof);
    }
    if (preArrivalFlow.policies !== PRE_ARRIVAL_INPUT.DISABLED) {
      formData.append("policyAccepted", String(agreePolicies));
    }
    if (typeof consentTexts !== "undefined") {
      formData.append("consentToText", String(consentTexts));
    }

    // Ensure the signature is a Blob if included
    if (preArrivalFlow.guestSignature !== PRE_ARRIVAL_INPUT.DISABLED) {
      let blobToAppend = null;
      if (signatureBlob instanceof Blob) {
        blobToAppend = signatureBlob;
      } else if (
        typeof signatureBlob === "string" &&
        signatureBlob.startsWith("data:image")
      ) {
        blobToAppend = dataUrlToBlob(signatureBlob);
      } else if (
        typeof signature === "string" &&
        signature.startsWith("data:image")
      ) {
        blobToAppend = dataUrlToBlob(signature);
      }
      if (blobToAppend) {
        formData.append("guestSignature", blobToAppend, "signature.png");
      }
    }

    // for (let [key, value] of formData.entries()) {
    //   console.log(`${key}:`, value);
    // }
    // console.log("qaqaqaqaqa", formData);
    try {
       // Debug: Log form data contents
       console.log("=== Form Data Contents ===");
       for (let [key, value] of formData.entries()) {
         console.log(`${key}:`, value);
       }
       console.log("=== End Form Data ===");
       
       const response = await axios.post(
         `${baseUrl}/guestApi/${guestSessionId}/preArrival`,
         formData,
         {
           headers: {
             "Content-Type": "multipart/form-data",
           },
         }
       );
       setCounter(counter + 1);

      // console.log(response);
    } catch (error) {
      let errorMessage =
        error.response?.data?.message ||
        "Failed to do PreArrival CheckIn. Please try again.";
      if (error.response?.data?.error.consentToText !== undefined) {
        errorMessage = error.response?.data?.error.consentToText[0];
      } else if (error.response?.data?.error.policyAccepted !== undefined) {
        errorMessage = error.response?.data?.error.policyAccepted[0];
      } else if (error.response?.data?.error.arrivalTime !== undefined) {
        errorMessage = error.response?.data?.error.arrivalTime[0];
      } else if (error.response?.data?.error.emailAddress !== undefined) {
        errorMessage = error.response?.data?.error.emailAddress[0];
      } else if (error.response?.data?.error.phoneNumber !== undefined) {
        errorMessage = error.response?.data?.error.phoneNumber[0];
      } else if (error.response?.data?.error.guestIdProof !== undefined) {
        errorMessage = error.response?.data?.error.guestIdProof[0];
      } else if (error.response?.data?.error.licensePlateNo !== undefined) {
        errorMessage = error.response?.data?.error.licensePlateNo[0];
      } else if (error.response?.data?.error.specialRequests !== undefined) {
        errorMessage = error.response?.data?.error.specialRequests[0];
      } else if (
        error.response?.data?.error.vehicleMakeModelColor !== undefined
      ) {
        errorMessage = error.response?.data?.error.vehicleMakeModelColor[0];
      }
      console.log("errormessage", errorMessage);
      setPreArrivalLoading(false);
      alert(errorMessage);
    }
  };

  function formatDateTime(date, time) {
    // Convert 'DD-MM-YYYY' to 'YYYY-MM-DD'
    const [day, month, year] = date.split("-");
    const formattedDate = `${year}-${month}-${day}`;

    // Combine the formatted date and time into a single string in the format 'YYYY-MM-DDTHH:mm:ss'
    const dateTimeString = `${formattedDate}T${time}Z`; // 'Z' makes it UTC

    return dateTimeString;
  }

  return (
    <>
      <Navbar counter={counter} />
      {!preArrivalFlow && !guest && <LoadingSpinner />}
      {counter % 4 === 0 && preArrivalFlow && (
        <>
          <div className="bg-gray-900 min-h-screen flex flex-col justify-between items-center">
            <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-sm m-6">
              <div className="text-gray-400 flex justify-between">
                <div>
                  <div className="text-lg font-semibold mb-2">
                    Pre-Arrival Check In
                  </div>
                  <div className="text-gray-500 text-sm mb-6">(Time Zone)</div>
                </div>
                <div>1/3</div>
              </div>
              <form>
                {preArrivalFlow.phoneNumber !== PRE_ARRIVAL_INPUT.DISABLED && (
                  <div className="mb-4">
                    <label className="text-gray-700 text-sm font-bold mb-2 flex justify-start">
                      Phone Number
                      {preArrivalFlow.phoneNumber ===
                        PRE_ARRIVAL_INPUT.REQUIRED && "*"}
                    </label>

                    <PhoneInput
                      country={"in"}
                      value={phone}
                      onChange={(phone, country) => {
                        setPhone(phone);
                        // Extract country code and phone number separately
                        const phoneString = String(phone);
                        
                        // Use the country object to get the dial code
                        const dialCode = country?.dialCode ? `+${country.dialCode}` : "";
                        // Remove the dial code digits (without +) from the phone string
                        const dialCodeDigits = country?.dialCode || "";
                        const extractedPhoneNumber = dialCodeDigits ? phoneString.replace(dialCodeDigits, "") : phoneString;
                        
                        setCountryCode(dialCode);
                        setPhoneNumber(extractedPhoneNumber);
                      }}
                      inputClass="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      buttonClass="bg-gray-200"
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    />
                  </div>
                )}
                {preArrivalFlow.emailAddress !== PRE_ARRIVAL_INPUT.DISABLED && (
                  <div className="mb-4">
                    <label className="flex justify-start text-gray-700 text-sm font-bold mb-2">
                      Email address *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                    {emailError && (
                      <p className="text-red-600 text-sm text-left">
                        Email is required
                      </p>
                    )}
                  </div>
                )}

                {preArrivalFlow.guestIdProof !== PRE_ARRIVAL_INPUT.DISABLED && (
                  <div className="mb-4">
                    <label className="flex justify-start text-gray-700 text-sm font-bold mb-2">
                      ID Verification *
                    </label>
                    <div className="text-gray-900 text-sm font-semibold font-poppins mb-2 flex justify-start break-words items-start">
                      Please take a photo of your driver's license or government issued ID
                    </div>
                    {idProof && (
                      <div className="text-black text-sm font-poppins mb-4 flex justify-start break-words items-start">
                        (To select different image,{" "}
                        <span
                          onClick={handleIconClick}
                          className="underline cursor-pointer text-indigo-600"
                        >
                          click here
                        </span>
                        )
                      </div>
                    )}
                    <div
                      className="border border-gray-400 p-6 rounded-md flex flex-col items-center justify-center mb-4"
                      onClick={handleIconClick}
                    >
                      <div className="w-full h-full flex items-center justify-center rounded-full mb-2">
                        <MdPhotoCamera
                          className={`w-14 h-14 cursor-pointer ${
                            idProof ? "hidden" : ""
                          }`}
                        />
                        <input
                          type="file"
                          accept="image/*"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleImageChange}
                        />
                        {idProof && (
                          <div className="mt-4">
                            <img
                              src={URL.createObjectURL(idProof)}
                              alt="Selected"
                              className="object-cover max-w-full max-h-32"
                            />
                          </div>
                        )}
                      </div>
                      <div
                        className={`text-gray-900 font-semibold font-poppins text-center text-xs mt-4 ${
                          idProof ? "hidden" : ""
                        }`}
                      >
                        We will not have access to ID in this system after your stay concludes
                      </div>
                    </div>
                    {idProofError && (
                      <p className="text-red-600 text-sm text-left">
                        Photo ID proof is required
                      </p>
                    )}
                  </div>
                )}

                {preArrivalFlow.policies !== PRE_ARRIVAL_INPUT.DISABLED && (
                  <>
                    {/* Render the policies section */}
                    {preArrivalFlow.propertyPolicies && (
                      <div className="mb-4">
                        <p className="flex justify-start text-gray-700 text-sm font-bold mb-2">
                          Please Review The Following Hotel Policies
                        </p>
                        <ul>
                          {preArrivalFlow.propertyPolicies.map(
                            (policy, index) => (
                              <li key={index} className="mb-2">
                                <label className="flex items-center">
                                  <input
                                    type="checkbox"
                                    checked={
                                      checkedPolicies[policy.name] || false
                                    } // Check the checkbox state
                                    onChange={() =>
                                      handleCheckboxChange(policy.name)
                                    } // Handle change
                                    className="form-checkbox text-indigo-600 mr-2"
                                  />
                                  <span className="text-gray-700">
                                    {policy.name}
                                  </span>
                                  <span
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleViewPolicy(policy);
                                    }}
                                    className="text-indigo-600 underline text-sm ml-2"
                                  >
                                    view
                                  </span>
                                </label>

                                {validationErrors[policy.name] && (
                                  <p className="text-red-500 text-xs mt-1">
                                    Please select this policy.
                                  </p>
                                )}
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    )}

                    {/* Bottom sheet modal for showing the policy description */}
                    <BottomSheetModal
                      isOpen={isPolicyModalOpen}
                      onClose={closeModal}
                    >
                      {viewPolicy && (
                        <div>
                          <h2 className="text-lg font-bold mb-4">
                            {viewPolicy.name}
                          </h2>
                          <p className="text-gray-700">
                            {viewPolicy.description ||
                              "No description available."}
                          </p>
                        </div>
                      )}
                    </BottomSheetModal>
                  </>
                )}

                <div className="mb-4">
                  <label className="flex items-baseline">
                    <input
                      type="checkbox"
                      name="consentTexts"
                      checked={consentTexts}
                      onChange={() => setConsentTexts(!consentTexts)}
                      className="form-checkbox text-indigo-600 mr-2"
                    />
                    <span className="text-gray-700">
                      I consent to receive texts and emails related to both my
                      stay and future marketing materials
                    </span>
                  </label>
                </div>

                {preArrivalFlow.guestSignature !==
                  PRE_ARRIVAL_INPUT.DISABLED && (
                  <div className="relative">
                    <label className="flex justify-start text-gray-700 text-sm font-bold mb-2">
                      Signature *
                    </label>
                    {!isDrawing && (
                      <div className="absolute inset-0 flex flex-col items-center justify-center text-gray-500 pointer-events-none">
                        <span className="text-lg">SIGNATURE BOARD</span>
                        <span className="text-xs pt-5">
                          Use your mouse or finger to draw your signature
                        </span>
                      </div>
                    )}
                    <SignatureCanvas
                      ref={handleSigCanvasRef}
                      penColor="black"
                      onBegin={handleBegin}
                      onEnd={saveSignatureToState}
                      canvasProps={{
                        className:
                          "w-full h-48 border border-gray-400 rounded-md",
                      }}
                    />
                    <button
                      type="button"
                      onClick={clearSignature}
                      className="absolute top-1 right-1 text-rose-500 px-2 py-1 text-xs bg-white/80 hover:bg-white rounded shadow-sm z-10"
                    >
                      clear
                    </button>
                  </div>
                )}
                {signatureError && (
                  <p className="text-red-600 text-xl text-center">
                    Signature is required
                  </p>
                )}
              </form>
            </div>
            <div className="text-center mb-6 text-gray-50 text-sm">
              Powered By Onelyk.Com
              <div className="mt-2 space-x-4">
                <a href="/terms" className="text-blue-400 hover:underline">
                  Terms and Conditions
                </a>
                <a href="/privacy" className="text-blue-400 hover:underline">
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>
          <div className="w-full bg-gray-700 p-4">
            <button
              className="w-full mb-5 border-2 border-gray-50 py-2 bg-indigo-600 text-white rounded-lg shadow-md hover:bg-indigo-400 focus:outline-none focus:shadow-outline"
              onClick={() => {
                saveSignature();
              }}
              type="submit"
            >
              Next
            </button>
          </div>
          {isModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-40">
              {guest && (
                <DateandTimePicker
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  setRequestSent={(time) => {
                    setSelectedTime(time);
                    // dispatch(setEarlyCheckInTime(time));
                    handleEarlyCheckInAddon(time);
                  }}
                  propertyTimeZone={propertyTimeZone}
                  date={guest && guest.checkIn}
                  addon={storeAddOns.allAddOns.find((addon) => {
                    if (
                      addon.addOnType !== "CustomAddon" &&
                      addon.name
                        .toLowerCase()
                        .replace(/\s+/g, "")
                        .includes("early")
                    )
                      return addon;
                  })}
                  propertyEarlyCheckInTime={propertyEarlyCheckInTime}
                  propertyTime={propertyCheckInTime}
                />
              )}
            </div>
          )}
        </>
      )}

      {counter % 4 === 1 && addOns && (
        <>
          <div className="relative h-screen overflow-auto pb-8">
            <div
              className={`flex flex-col justify-start items-center bg-gray-900 min-h-full w-full ${
                isModalOpen ? "opacity-30" : "opacity-100"
              }`}
            >
              <div
                className={`bg-white p-4 rounded-lg shadow-md w-full max-w-sm mx-6 my-6`}
              >
                <div className={`text-gray-400 flex justify-between`}>
                  <div>
                    <div className="text-lg font-poppins mb-2">Add-Ons</div>
                  </div>
                  <div>2/3</div>
                </div>
                <div className="mt-4 mb-4">
                  <div className="space-y-4">
                    {storeAddOns.allAddOns.map((addOn) => (
                      <div key={addOn._id} className="rounded-md">
                        <div className="bg-gray-200  mb-2 rounded-md">
                          <img
                            src={(() => {
                              if (addOn.name?.toLowerCase().includes("early")) {
                                return "https://onelyk-images-bucket.s3.us-east-1.amazonaws.com/addOns/early+check+in.png";
                              } else if (
                                addOn.name?.toLowerCase().includes("late")
                              ) {
                                return "https://onelyk-images-bucket.s3.us-east-1.amazonaws.com/addOns/late+check+out.png";
                              } else if (addOn.image) {
                                return addOn.image;
                              } else {
                                return "https://st3.depositphotos.com/1022597/35608/i/450/depositphotos_356083076-stock-photo-grey-stone-texture-useful-background.jpg";
                              }
                            })()}
                            className="w-full h-36"
                          />
                        </div>
                        <div className="flex justify-between">
                          <div className="text-lg font-semibold">
                            {addOn.name}
                          </div>
                          <div className="text-lg font-semibold">
                            ${addOn.price}
                          </div>
                        </div>
                        <div className="text-gray-500 mb-2 text-sm flex justify-start">
                          {addOn.description}
                        </div>
                        {addOn.addOnType !== "CustomAddon" ? (
                          <>
                            {addOn.name.toLowerCase().includes("early") ? (
                              <>
                                <input
                                  type="text"
                                  value={
                                    storeAddOns?.guestCheckInOutRequests?.find(
                                      (selectedAddOn) =>
                                        selectedAddOn.requestType ===
                                        "earlyCheckIn"
                                    )
                                      ? new Date(
                                          storeAddOns.guestCheckInOutRequests.find(
                                            (selectedAddOn) =>
                                              selectedAddOn.requestType ===
                                              "earlyCheckIn"
                                          ).earlyCheckInDateTime
                                        ).toLocaleString("en", {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: true,
                                          timeZone: "UTC",
                                        })
                                      : selectedTime ||
                                        convert24to12(propertyCheckInTime)
                                  }
                                  readOnly
                                  disabled={
                                    storeAddOns &&
                                    storeAddOns.guestCheckInOutRequests.length >
                                      0 &&
                                    storeAddOns.guestCheckInOutRequests.some(
                                      (selectedAddOn) =>
                                        selectedAddOn.requestType ===
                                          "earlyCheckIn" &&
                                        ["Requested", "Accepted"].includes(
                                          selectedAddOn.requestStatus
                                        )
                                    )
                                  }
                                  onClick={() => setIsModalOpen(true)}
                                  className="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                />
                                {loadingAddOnId === addOn._id && (
                                  <button
                                    className="w-full py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                                    onClick={() => handleSendRequest(addOn)}
                                    disabled={loadingAddOnId === addOn._id}
                                  >
                                    {loadingAddOnId === addOn._id && (
                                      <>
                                        <svg
                                          className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                        >
                                          <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                          />
                                          <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                          />
                                        </svg>
                                        Processing...
                                      </>
                                    )}
                                  </button>
                                )}

                                {storeAddOns?.guestCheckInOutRequests?.some(
                                  (selectedAddOn) =>
                                    selectedAddOn.requestType ===
                                      "earlyCheckIn" &&
                                    selectedAddOn.requestStatus !== "Declined"
                                ) && (
                                  <button
                                    className="w-full py-2 bg-green-100 text-green-700 rounded-md flex items-center justify-center"
                                    disabled
                                  >
                                    <span className="mr-2">
                                      <Tick />
                                    </span>
                                    {storeAddOns.guestCheckInOutRequests.find(
                                      (selectedAddOn) =>
                                        selectedAddOn.requestType ===
                                        "earlyCheckIn"
                                    )?.requestStatus === "Accepted"
                                      ? "Request Accepted"
                                      : "Request Sent"}
                                  </button>
                                )}
                              </>
                            ) : (
                              <>
                                <input
                                  type="text"
                                  value={
                                    storeAddOns?.guestCheckInOutRequests?.find(
                                      (selectedAddOn) =>
                                        selectedAddOn.requestType ===
                                        "lateCheckOut"
                                    )
                                      ? new Date(
                                          storeAddOns.guestCheckInOutRequests.find(
                                            (selectedAddOn) =>
                                              selectedAddOn.requestType ===
                                              "lateCheckOut"
                                          ).lateCheckOutDateTime
                                        ).toLocaleString("en", {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: true,
                                          timeZone: "UTC",
                                        })
                                      : lateCheckoOutSelectedTime ||
                                        convert24to12(propertyCheckOutTime)
                                  }
                                  readOnly
                                  disabled={
                                    storeAddOns &&
                                    storeAddOns.guestCheckInOutRequests.length >
                                      0 &&
                                    storeAddOns.guestCheckInOutRequests.some(
                                      (selectedAddOn) =>
                                        selectedAddOn.requestType ===
                                          "lateCheckOut" &&
                                        ["Requested", "Accepted"].includes(
                                          selectedAddOn.requestStatus
                                        )
                                    )
                                  }
                                  onClick={() =>
                                    setIsLateCheckOutModalOpen(true)
                                  }
                                  className="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                />
                                {loadingAddOnId === addOn._id && (
                                  <button
                                    className="w-full py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                                    onClick={() => handleSendRequest(addOn)}
                                    disabled={loadingAddOnId === addOn._id}
                                  >
                                    {loadingAddOnId === addOn._id && (
                                      <>
                                        <svg
                                          className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                        >
                                          <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                          />
                                          <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                          />
                                        </svg>
                                        Processing...
                                      </>
                                    )}
                                  </button>
                                )}
                                {storeAddOns?.guestCheckInOutRequests?.some(
                                  (selectedAddOn) =>
                                    selectedAddOn.requestType ===
                                      "lateCheckOut" &&
                                    selectedAddOn.requestStatus !== "Declined"
                                ) && (
                                  <button
                                    className="w-full py-2 bg-green-100 text-green-700 rounded-md flex items-center justify-center"
                                    disabled
                                  >
                                    <span className="mr-2">
                                      <Tick />
                                    </span>
                                    {storeAddOns.guestCheckInOutRequests.find(
                                      (selectedAddOn) =>
                                        selectedAddOn.requestType ===
                                        "lateCheckOut"
                                    )?.requestStatus === "Accepted"
                                      ? "Request Accepted"
                                      : "Request Sent"}
                                  </button>
                                )}
                              </>
                            )}
                          </>
                        ) : storeAddOns.guestAddons.some(
                            (selectedAddOn) =>
                              selectedAddOn.addOnsId === addOn._id &&
                              selectedAddOn.requestStatus !== "Declined"
                          ) ? (
                          <button
                            className="w-full py-2 bg-green-100 text-green-700 rounded-md flex items-center justify-center"
                            disabled
                          >
                            <span className="mr-2">
                              <Tick />
                            </span>

                            {storeAddOns.guestAddons.find(
                              (selectedAddOn) =>
                                selectedAddOn.addOnsId === addOn._id
                            )?.requestStatus === "Accepted"
                              ? "Request Accepted"
                              : "Request Sent"}
                          </button>
                        ) : (
                          <button
                            className="w-full py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                            onClick={() => handleSendRequest(addOn)}
                            disabled={loadingAddOnId === addOn._id}
                          >
                            {loadingAddOnId === addOn._id ? (
                              <>
                                <svg
                                  className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  />
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  />
                                </svg>
                                Processing...
                              </>
                            ) : (
                              "Send Request"
                            )}
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {isLateCheckOutModalOpen && (
              <div className="fixed inset-0 bg-black bg-opacity-50 z-40">
                {guest && (
                  <LateCheckoutTimePicker
                    isModalOpen={isLateCheckOutModalOpen}
                    setIsModalOpen={setIsLateCheckOutModalOpen}
                    setRequestSent={(date, time) => {
                      setLateCheckoOutSelectedTime(time);
                      handleLateCheckOutAddon(time);
                    }}
                    propertyLateCheckOutTime={propertyLateCheckOutTime}
                    propertyTime={propertyCheckOutTime}
                    checkOutDate={guest && guest.checkOut}
                    lateCheckOutFlag={true}
                    propertyTimeZone={propertyTimeZone}
                    checkoutDate={guest && guest.checkOut}
                    addon={storeAddOns.allAddOns.find((addon) => {
                      if (
                        addon.addOnType !== "CustomAddon" &&
                        addon.name
                          .toLowerCase()
                          .replace(/\s+/g, "")
                          .includes("late")
                      )
                        return addon;
                    })}
                  />
                )}
              </div>
            )}
            {isModalOpen && (
              <div className="fixed inset-0 bg-black bg-opacity-50 z-40">
                {guest && (
                  <DateandTimePicker2
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    setRequestSent={(time) => {
                      setSelectedTime(time);
                      //dispatch(setEarlyCheckInTime(time));
                      handleEarlyCheckInAddon(time);
                    }}
                    date={guest && guest.checkIn}
                    propertyTimeZone={propertyTimeZone}
                    propertyEarlyCheckInTime={propertyEarlyCheckInTime}
                    propertyTime={propertyCheckInTime}
                    addon={storeAddOns.allAddOns.find((addon) => {
                      if (
                        addon.addOnType !== "CustomAddon" &&
                        addon.name
                          .toLowerCase()
                          .replace(/\s+/g, "")
                          .includes("early")
                      )
                        return addon;
                    })}
                  />
                )}
              </div>
            )}
          </div>
          <div className="fixed bottom-0 inset-x-0 w-full bg-gray-700 p-4">
            <button
              className="w-full mb-5 border-2 border-gray-50 py-2 bg-indigo-600 text-white rounded-lg shadow-md hover:bg-indigo-400 focus:outline-none focus:shadow-outline"
              onClick={handleSubmit}
            >
              Skip
            </button>
          </div>
        </>
      )}

      {counter % 4 === 2 && preArrivalFlow && (
        <>
          <div className="flex justify-center">
            <div className="flex flex-col h-auto bg-white p-6 rounded-lg shadow-md w-full max-w-sm m-6 ">
              <div>
                <div className="flex justify-between items-center mb-4">
                  <div className="text-xl font-semibold text-gray-400">
                    Arrival Time
                  </div>
                  <div className="text-gray-500">3/3</div>
                </div>
                
                <div className="mb-4">
                  <label className="flex justify-start text-gray-700 text-sm font-bold mb-2">
                    {/* Arrival Time ({propertyTimeZone}) */}
                    Arrival Time
                  </label>
                  <input
                    type="text"
                    value={
                      storeAddOns &&
                      storeAddOns.guestCheckInOutRequests.length > 0
                        ? storeAddOns.guestCheckInOutRequests.find(
                            (selectedAddOn) =>
                              selectedAddOn.requestType === "earlyCheckIn"
                          )
                          ? new Date(
                              storeAddOns.guestCheckInOutRequests.find(
                                (selectedAddOn) =>
                                  selectedAddOn.requestType === "earlyCheckIn"
                              ).earlyCheckInDateTime
                            ).toLocaleString("en", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                              timeZone: "UTC",
                            })
                          : selectedTime
                          ? selectedTime
                          : convert24to12(propertyCheckInTime)
                        : selectedTime
                        ? selectedTime
                        : convert24to12(propertyCheckInTime)
                    }
                    readOnly
                    disabled={
                      storeAddOns &&
                      storeAddOns.guestCheckInOutRequests.length > 0 &&
                      storeAddOns.guestCheckInOutRequests.some(
                        (selectedAddOn) =>
                          selectedAddOn.requestType === "earlyCheckIn" &&
                          ["Requested", "Accepted"].includes(
                            selectedAddOn.requestStatus
                          )
                      )
                    }
                    onClick={() => setIsModalOpen(true)}
                    className="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline cursor-pointer"
                  />
                  {isEarlyCheckInLoading && (
                    <button
                      className="w-full py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                      disabled={isEarlyCheckInLoading}
                    >
                      <>
                        <svg
                          className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          />
                        </svg>
                        Processing...
                      </>
                    </button>
                  )}

                  {storeAddOns &&
                    storeAddOns.guestCheckInOutRequests.length > 0 &&
                    storeAddOns.guestCheckInOutRequests.some(
                      (selectedAddOn) =>
                        selectedAddOn.requestType === "earlyCheckIn" &&
                        selectedAddOn.requestStatus !== "Declined"
                    ) && (
                      <button
                        className="w-full py-2 bg-green-100 text-green-700 rounded-md flex items-center justify-center"
                        disabled
                      >
                        <span className="mr-2">
                          <Tick />
                        </span>
                        {storeAddOns &&
                          storeAddOns.guestCheckInOutRequests.length > 0 &&
                          storeAddOns.guestCheckInOutRequests.find(
                            (selectedAddOn) =>
                              selectedAddOn.requestType === "earlyCheckIn"
                          )?.requestStatus === "Accepted" &&
                          "Request Accepted"}
                        {storeAddOns &&
                          storeAddOns.guestCheckInOutRequests.length > 0 &&
                          storeAddOns.guestCheckInOutRequests.find(
                            (selectedAddOn) =>
                              selectedAddOn.requestType === "earlyCheckIn"
                          )?.requestStatus === "Requested" &&
                          "Request Sent"}
                      </button>
                    )}
                </div>

                {/* Vehicle and Special Requests Fields */}
                <div className="flex mb-4">
                  {preArrivalFlow.vehicleMakeModelColor !==
                    PRE_ARRIVAL_INPUT.DISABLED && (
                    <div className="w-1/2 pr-2">
                      <label className="flex justify-start text-gray-700 text-sm font-bold mb-2">
                        Vehicle Make / Model / Color
                      </label>
                      <input
                        type="text"
                        name="vehicleMake"
                        value={vehicleMake}
                        onChange={(e) => setVehicleMake(e.target.value)}
                        className="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      />
                    </div>
                  )}
                  {preArrivalFlow.licensePlateNo !==
                    PRE_ARRIVAL_INPUT.DISABLED && (
                    <div className="w-1/2 pl-2">
                      <label className="flex justify-start text-gray-700 text-sm font-bold mb-2">
                        License Plate #
                        {preArrivalFlow.licensePlateNo === PRE_ARRIVAL_INPUT.REQUIRED && " *"}
                      </label>
                      <input
                        type="text"
                        name="licensePlate"
                        value={licensePlate}
                        onChange={(e) => setLicensePlate(e.target.value)}
                        className="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      />
                      {licensePlateError && (
                        <p className="text-red-600 text-sm text-left">
                          License plate is required
                        </p>
                      )}
                    </div>
                  )}
                </div>
                {preArrivalFlow.specialRequests !==
                  PRE_ARRIVAL_INPUT.DISABLED && (
                  <div className="mb-4">
                    <label className="flex justify-start text-gray-700 text-sm font-bold mb-2">
                      Special Requests
                    </label>
                    <textarea
                      name="specialRequests"
                      value={specialRequests}
                      onChange={(e) => setSpecialRequests(e.target.value)}
                      className="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                  </div>
                )}
              </div>
              <div className="fixed bottom-0 left-0 w-full bg-gray-700 p-4">
                <button
                  className="flex flex-row mb-5 items-center justify-center w-full border-2 border-gray-50 py-2 bg-indigo-600 text-white rounded-lg shadow-md hover:bg-indigo-400 focus:outline-none focus:shadow-outline"
                  onClick={handleSubmit}
                  disabled={preArrivalLoading}
                >
                  {preArrivalLoading ? (
                    <>
                      <svg
                        className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                      </svg>
                      Processing...
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </div>
          </div>
          
          {isModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-40">
              {guest && (
                <ArrivalTimePicker
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  setRequestSent={(time) => {
                    setSelectedTime(time);
                    // dispatch(setEarlyCheckInTime(time));
                    handleEarlyCheckInAddon(time);
                  }}
                  setTimeOnly={(time) => {
                    setSelectedTime(time);
                  }}
                  currentSelectedTime={selectedTime}
                  propertyTimeZone={propertyTimeZone}
                  date={guest && guest.checkIn}
                  addon={storeAddOns.allAddOns.find((addon) => {
                    if (
                      addon.addOnType !== "CustomAddon" &&
                      addon.name
                        .toLowerCase()
                        .replace(/\s+/g, "")
                        .includes("early")
                    )
                      return addon;
                  })}
                  propertyEarlyCheckInTime={propertyEarlyCheckInTime}
                  propertyTime={propertyCheckInTime}
                />
              )}
            </div>
          )}
        </>
      )}

      {counter % 4 === 3 && (
        <>
          <div className="flex justify-center">
            <div className="bg-white p-8 rounded-xl shadow-md w-full h-auto max-w-sm m-6 ">
              <div className="text-gray-400 flex justify-between mb-6">
                <div className="flex items-center justify-center">
                  <Tick />
                  <div className="text-xl ml-2 text-gray-900">Done</div>
                </div>
                <div>3/3</div>
              </div>

              <div className="font-poppins  text-gray-900 mb-3">
                Pre Arrival Check In Is done
              </div>

              <hr className="mb-3" />
              {propertyEarlyCheckInTime && (
                <>
                  <div className="flex justify-between">
                    <div className="text-lg font-semibold">
                      Would Like To Early Check In?
                    </div>
                  </div>
                  <div className="text-gray-500 mb-4 mt-2 text-sm flex justify-start">
                    Come Enjoy The Room And The Facilities Early Subject To
                    Availability
                  </div>

                  <input
                    type="text"
                    value={
                      storeAddOns &&
                      storeAddOns.guestCheckInOutRequests.length > 0
                        ? storeAddOns.guestCheckInOutRequests.find(
                            (selectedAddOn) =>
                              selectedAddOn.requestType === "earlyCheckIn"
                          )
                          ? new Date(
                              storeAddOns.guestCheckInOutRequests.find(
                                (selectedAddOn) =>
                                  selectedAddOn.requestType === "earlyCheckIn"
                              ).earlyCheckInDateTime
                            ).toLocaleString("en", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,

                              timeZone: "UTC",
                            })
                          : selectedTime
                          ? selectedTime
                          : convert24to12(
                              propertyEarlyCheckInTime?.defaultTiming
                            )
                        : selectedTime
                        ? selectedTime
                        : convert24to12(propertyEarlyCheckInTime?.defaultTiming)
                    }
                    readOnly
                    disabled={
                      storeAddOns &&
                      storeAddOns.guestCheckInOutRequests.length > 0 &&
                      storeAddOns.guestCheckInOutRequests.some(
                        (selectedAddOn) =>
                          selectedAddOn.requestType === "earlyCheckIn" &&
                          ["Requested", "Accepted", "Declined"].includes(
                            selectedAddOn.requestStatus
                          )
                      )
                    }
                    onClick={() => setIsModalOpen(true)}
                    className="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                  {isEarlyCheckInLoading && (
                    <button
                      className="w-full py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                      disabled={isEarlyCheckInLoading}
                    >
                      <>
                        <svg
                          className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          />
                        </svg>
                        Processing...
                      </>
                    </button>
                  )}

                  {storeAddOns &&
                    storeAddOns.guestCheckInOutRequests.length > 0 &&
                    storeAddOns.guestCheckInOutRequests.some(
                      (selectedAddOn) =>
                        selectedAddOn.requestType === "earlyCheckIn" &&
                        selectedAddOn.requestStatus !== "Declined"
                    ) && (
                      <button
                        className="w-full py-2 bg-green-100 text-green-700 rounded-md flex items-center justify-center"
                        disabled
                      >
                        <span className="mr-2">
                          <Tick />
                        </span>
                        {storeAddOns &&
                          storeAddOns.guestCheckInOutRequests.length > 0 &&
                          storeAddOns.guestCheckInOutRequests.find(
                            (selectedAddOn) =>
                              selectedAddOn.requestType === "earlyCheckIn"
                          )?.requestStatus === "Accepted" &&
                          "Request Accepted"}
                        {storeAddOns &&
                          storeAddOns.guestCheckInOutRequests.length > 0 &&
                          storeAddOns.guestCheckInOutRequests.find(
                            (selectedAddOn) =>
                              selectedAddOn.requestType === "earlyCheckIn"
                          )?.requestStatus === "Requested" &&
                          "Request Sent"}
                      </button>
                    )}
                </>
              )}

              <hr className="mb-3" />
              {propertyLateCheckOutTime && (
                <>
                  <div className="flex justify-between">
                    <div className="text-lg font-semibold">
                      Would Like To Late Check Out?
                    </div>
                  </div>
                  <div className="text-gray-500 mb-4 mt-2 text-sm flex justify-start">
                    Come Enjoy The Room And The Facilities Early Subject To
                    Availability
                  </div>

                  <input
                    type="text"
                    value={
                      storeAddOns?.guestCheckInOutRequests?.find(
                        (selectedAddOn) =>
                          selectedAddOn.requestType === "lateCheckOut"
                      )
                        ? new Date(
                            storeAddOns.guestCheckInOutRequests.find(
                              (selectedAddOn) =>
                                selectedAddOn.requestType === "lateCheckOut"
                            ).lateCheckOutDateTime
                          ).toLocaleString("en", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                            timeZone: "UTC",
                          })
                        : selectedTime ||
                          convert24to12(propertyLateCheckOutTime?.defaultTiming)
                    }
                    readOnly
                    disabled={
                      storeAddOns &&
                      storeAddOns.guestCheckInOutRequests.length > 0 &&
                      storeAddOns.guestCheckInOutRequests.some(
                        (selectedAddOn) =>
                          selectedAddOn.requestType === "lateCheckOut" &&
                          ["Requested", "Accepted"].includes(
                            selectedAddOn.requestStatus
                          )
                      )
                    }
                    onClick={() => setIsLateCheckOutModalOpen(true)}
                    className="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                  {isLateCheckOutLoading && (
                    <button
                      className="w-full py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                      disabled={isLateCheckOutLoading}
                    >
                      <>
                        <svg
                          className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          />
                        </svg>
                        Processing...
                      </>
                    </button>
                  )}

                  {storeAddOns?.guestCheckInOutRequests?.some(
                    (selectedAddOn) =>
                      selectedAddOn.requestType === "lateCheckOut" &&
                      selectedAddOn.requestStatus !== "Declined"
                  ) && (
                    <button
                      className="w-full py-2 bg-green-100 text-green-700 rounded-md flex items-center justify-center"
                      disabled
                    >
                      <span className="mr-2">
                        <Tick />
                      </span>
                      {storeAddOns.guestCheckInOutRequests.find(
                        (selectedAddOn) =>
                          selectedAddOn.requestType === "lateCheckOut"
                      )?.requestStatus === "Accepted"
                        ? "Request Accepted"
                        : "Request Sent"}
                    </button>
                  )}
                </>
              )}
            </div>

            <div className="fixed bottom-0 left-0 w-full bg-gray-700 p-4">
              <button
                className="w-full border-2 border-gray-50 py-2 bg-indigo-600 text-white rounded-lg shadow-md hover:bg-indigo-400 focus:outline-none focus:shadow-outline"
                onClick={() => {
                  navigateHome();
                }}
              >
                Back to Home
              </button>
            </div>
          </div>
          {isLateCheckOutModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-40">
              {guest && (
                <LateCheckoutTimePicker
                  isModalOpen={isLateCheckOutModalOpen}
                  setIsModalOpen={setIsLateCheckOutModalOpen}
                  setRequestSent={(date, time) => {
                    setLateCheckoOutSelectedTime(time);
                    handleLateCheckOutAddon(time);
                    //setSelectedDate(date);
                    // setConfirmLateCheckOutRequest(true);
                  }}
                  addon={storeAddOns.allAddOns.find((addon) => {
                    if (
                      addon.addOnType !== "CustomAddon" &&
                      addon.name
                        .toLowerCase()
                        .replace(/\s+/g, "")
                        .includes("late")
                    )
                      return addon;
                  })}
                  propertyLateCheckOutTime={propertyLateCheckOutTime}
                  propertyTime={propertyCheckOutTime}
                  checkOutDate={guest && guest.checkOut}
                  propertyTimeZone={propertyTimeZone}
                  lateCheckOutFlag={true}
                />
              )}
            </div>
          )}
          {isModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-40">
              {guest && (
                <DateandTimePicker2
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  setRequestSent={(time) => {
                    setSelectedTime(time);
                    // dispatch(setEarlyCheckInTime(time));
                    handleEarlyCheckInAddon(time);
                  }}
                  date={guest && guest.checkIn}
                  addon={storeAddOns.allAddOns.find((addon) => {
                    if (
                      addon.addOnType !== "CustomAddon" &&
                      addon.name
                        .toLowerCase()
                        .replace(/\s+/g, "")
                        .includes("early")
                    )
                      return addon;
                  })}
                  propertyTimeZone={propertyTimeZone}
                  propertyEarlyCheckInTime={propertyEarlyCheckInTime}
                  propertyTime={propertyCheckInTime}
                />
              )}
            </div>
          )}
        </>
      )}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default PreArrivalCheckIn;
